import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	activeScope: 'user',
	selectedCompanyId: null,
};

const activeContextSlice = createSlice({
	name: 'activeContext',
	initialState,
	reducers: {
		activateCompanyContext: (state, action) => {
			state.selectedCompanyId = action.payload;
			state.activeScope = 'company';
		},

		initializeCompanyContext: (state, action) => {
			if (!state.selectedCompanyId && action.payload) {
				state.selectedCompanyId = action.payload;
			}
		},

		activatePrivateContext: (state) => {
			state.selectedCompanyId = null;
			state.activeScope = 'user';
		},
	},
});

export const { activatePrivateContext, activateCompanyContext, initializeCompanyContext } =
	activeContextSlice.actions;

export const activeContextReducer = activeContextSlice.reducer;
